export function Testimonials() {
  const testimonials = [
    {
      name: "Antônio Roberto Sena",
      role: "Confeiteiro",
      text: "O PedidoZ revolucionou meu negócio. Antes eu perdia horas com planilhas confusas... agora, em minutos, tenho tudo organizado. É como ter um assistente pessoal!",
      image: "/testimonial1.webp",
    },
    {
      name: "Nathália Cordeiro",
      role: "Proprietária de Doceria",
      text: "Uso o PedidoZ há 6 meses na minha confeitaria e é simplesmente perfeito! Cadastro despesas, controlo vendas, acompanho lucros e não tenho limite de pedidos. Finalmente me livrei das planilhas — agora tudo é prático, visual e rápido. Meu negócio cresceu muito desde então!",
      image: "/testimonial2.webp",
    },
    {
      name: "Marina Costa",
      role: "Cake Designer",
      text: "Desde que comecei a usar o PedidoZ, não enfrento mais pedidos perdidos ou pagamentos atrasados. Tenho controle total e mais tempo para focar no que amo: criar!",
      image: "/testimonial3.webp",
    },
  ];

  return (
    <section className="py-20 px-4 container mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
        HISTÓRIAS DE{" "}
        <span className="text-gray-900 dark:text-gray-200 font-black">
          SUCESSO
        </span>
      </h2>

      <div className="grid md:grid-cols-3 gap-10">
        {testimonials.map((t, index) => (
          <div
            key={index}
            className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            <div className="flex flex-col items-center text-center">
              <div className="relative mb-4">
                <div className="absolute -top-2 -left-2 w-24 h-24 rounded-full bg-gradient-to-r from-[#FF9A3C] to-[#EE7B11] opacity-20 animate-pulse"></div>
                <img
                  src={t.image || "/placeholder.svg"}
                  alt={`Foto de ${t.name}`}
                  className="w-20 h-20 rounded-full object-cover border-2 border-[#EE7B11] relative z-10"
                />
              </div>

              <p className="text-gray-600 italic mb-6 max-w-sm">“{t.text}”</p>

              <h4 className="text-[#EE7B11] font-bold text-lg">{t.name}</h4>
              <p className="text-gray-500 text-sm">{t.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
